import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  apiEmNumLogin,
  apiGetCheckEmNumLogin,
  apiGetCommonCaptcha,
  apiGetEmCount,
  apiGetUserInfo,
  apiGetWeChatSignature,
  apiLogin,
  apiSetDefaultByEmNumber,
} from '../../api';
import Button from '../../components/button';
import Page from '../../components/page';
import RadioBox from '../../components/radioBox';
import main, { AppLocalKey } from '../../main';
import { ProtocolType } from '../../utils/dict';
import { LoadingMask, delay, showConfirm, showToast } from '../../utils/utils';

export default function LoginPage() {
  const { type, number, linkPhone } = useLocation().state || {};
  const navigate = useNavigate();

  const naviate = useNavigate();
  // 0 未准备 1可以使用  2 客户端不支持
  const [wxReady, setWxReady] = useState(0);
  // 登录方式 smsCode = 验证码登陆 emNumber = 设备号登陆
  const [loginType, setLoginType] = useState<string>(type || 'smsCode');
  // 设备号登录
  const [emNumber, setemNumber] = useState(number || '');
  // 检测是否已绑定设备号
  const [isBindEmNumber, setisBindEmNumber] = useState(false);
  const [phone, setPhone] = useState(linkPhone || '');
  const [captcha, setCaptcha] = useState('');
  const [checkProtocol, setCheckProtocol] = useState((type && number && linkPhone) || false);
  const timeRef = useRef<{ time: number; timer?: NodeJS.Timer }>({ time: 60, timer: undefined });
  const [captchaTime, setCaptchaTime] = useState(60);
  const [timing, setTiming] = useState(false);
  //卡库中的客服电话
  // const [serverPhone, setServerPhone] = useState('');
  useEffect(() => {
    if (type && number && linkPhone) {
      main.ispreview = true;
      handleLogin();
    }
  }, [type, number, linkPhone]); // eslint-disable-line
  const [historyPhone, setHistoryPhone] = useState<string[]>([]);
  const [showHistoryPhone, setShowHistoryPhone] = useState(false);
  const longTimeRef = useRef<{ time: number }>({
    time: 0,
  });
  useEffect(() => {
    let _phone = localStorage.getItem(AppLocalKey.loginUsername);
    if (_phone) {
      setPhone(_phone);
    }
    let _historyPhone = localStorage.getItem(AppLocalKey.historyPhone) ?? '';

    if (!!_historyPhone) {
      setHistoryPhone(_historyPhone.split(','));
    }
    // if (main.nextBindEm) {
    //   loadServerPhone();
    // }
    wxConfig();
  }, []); // eslint-disable-line

  async function wxConfig() {
    // @ts-ignore
    let wx = window.wx;
    let res = await apiGetWeChatSignature(
      main.isIos14 ? main.enterUrl : window.location.href.split('#')[0],
      main.appId,
    );
    let data = res.data;

    if (data.code === 200) {
      let _data = data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: main.appId, // 必填，公众号的唯一标识
        timestamp: _data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _data.nonceStr, // 必填，生成签名的随机串
        signature: _data.signature, // 必填，签名
        jsApiList: ['checkJsApi', 'scanQRCode'], // 必填，需要使用的JS接口列表
      });
    }

    wx.ready(() => {
      wx.checkJsApi({
        //判断当前客户端版本是否支持指定JS接口
        jsApiList: ['scanQRCode'],
        success: function (res: any) {
          // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
          if (res.checkResult.scanQRCode !== true) {
            showToast('抱歉，当前客户端版本不支持扫一扫');
            setWxReady(2);
          } else {
            setWxReady(1);
          }
        },
      });
    });
  }

  // async function loadServerPhone() {
  //   try {
  //     let res = await apiGetCardLibraryCustomer(main.nextBindEm!);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       let _phone = (data.data ?? []).find((i: any) => !!i.serverPhone)?.serverPhone;
  //       if (!!_phone) {
  //         setServerPhone(_phone);
  //       }
  //     }
  //   } catch (e: any) {}
  // }

  function startTimer() {
    let jsTimer: NodeJS.Timer = setInterval(() => {
      let t = timeRef.current.time - 1;
      if (t <= 0) {
        setTiming(false);
        clearInterval(timeRef.current.timer);
        timeRef.current.timer = undefined;
      }
      timeRef.current.time = t;
      setCaptchaTime(t);
    }, 1000);
    timeRef.current.timer = jsTimer;
  }

  async function handleGetCaptcha() {
    if (timeRef.current.timer) return;
    if (!/^1[0-9]{10}$/.test(phone)) {
      return showToast('请输入正确的手机号');
    }

    LoadingMask.show('正在发送...');
    try {
      let res = await apiGetCommonCaptcha(phone);
      let data = res.data;
      if (data.code === 200) {
        showToast(data.msg ?? '验证码已发送');
        setTiming(true);
        setCaptchaTime(60);
        timeRef.current.time = 60;
        startTimer();
      } else {
        showToast(data.msg || '发送失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '验证码发送失败,请稍后再试');
    } finally {
      LoadingMask.hide();
      longTimeRef.current.time++;
      if (longTimeRef.current.time >= 3) {
        handleLongTimeDialog();
      }
    }
  }

  async function handleLongTimeDialog() {
    let res = await showConfirm({
      title: '提示',
      content: '是否需要联系客服协助？',
      hideCancelBtn: true,
      confirmBtnText: '联系客服',
    });
    if (res === 1) {
      navigate('/customer');
    }
  }

  function scanCode() {
    if (!window.parent || !window.parent.postMessage) {
      return showToast('当前环境不支持扫码功能');
    }
    if (wxReady === 0) {
      return showToast('微信相机正在准备，请稍后再试');
    } else if (wxReady === 2) {
      return showToast('抱歉，当前客户端版本不支持扫一扫');
    }
    // @ts-ignore
    let wx = window.wx;
    // 调起企业微信扫一扫接口
    wx.scanQRCode({
      desc: 'scanQRCode desc',
      needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
      scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res: any) {
        var result: string = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        if (result.includes(',')) {
          result = result.split(',')[1];
        }
        setemNumber(result);
        getCheckEmNumLogin(result);
      },
      error: function (res: any) {
        if (res.errMsg.indexOf('function_not_exist') > 0) {
          showToast('微信版本过低请升级');
        }
      },
    }); //wx.scanQRcode结束
  }
  // 检测当前设备号是否绑定手机号
  async function getCheckEmNumLogin(emNumber: string) {
    if (!emNumber) return;
    let res = await apiGetCheckEmNumLogin(emNumber);
    let data = res.data;
    if (data.code === 200) {
      setisBindEmNumber(data.data);
    }
  }

  async function handleLogin() {
    let exp = /^1[0-9]{10}$/;
    if (!exp.test(phone)) {
      return showToast('手机号格式不正确');
    } else if (loginType === 'smsCode' && !captcha) {
      return showToast('请输入验证码');
    } else if (loginType === 'emNumber' && !emNumber) {
      return showToast('请输入设备号');
    } else if (!checkProtocol) {
      let modalRes = await showConfirm({
        title: '温馨提示',
        content: '点击同意表示您已阅读并同意《用户协议》和《隐私政策》',
        confirmBtnText: '同意',
      });
      if (!modalRes) return;
    }
    localStorage.setItem(AppLocalKey.loginUsername, phone);
    LoadingMask.show('正在登录...');
    try {
      let fn = loginType === 'smsCode' ? apiLogin(phone, captcha) : apiEmNumLogin({ emNumber, phonenumber: phone });
      let res = await fn;
      let data = res.data;
      if (data.code === 200) {
        let token = data.data.access_token;
        main.loginKey = token;
        localStorage.setItem(AppLocalKey.loginToken, token);
        main.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        // 设备号登录成功后，设置默认设备
        if (loginType === 'emNumber' && emNumber) {
          try {
            let defaultRes = await apiSetDefaultByEmNumber(emNumber);
            let defaultData = defaultRes.data;
            if (defaultData.code !== 200) {
              showToast(defaultData.msg ?? '设置默认设备失败');
              return;
            }
          } catch (e: any) {
            showToast(e.response?.data?.msg ?? e.message ?? '设置默认设备失败');
            return;
          }
        }

        let userInfoRes = await apiGetUserInfo(token);
        let userInfoData = userInfoRes.data;
        if (userInfoData.code === 200) {
          main.user = userInfoData.data.user;
          showToast('登录成功');
          let historyPhone = localStorage.getItem(AppLocalKey.historyPhone) ?? '';
          if (!!historyPhone) {
            if (!historyPhone.includes(phone)) {
              historyPhone = `${phone},` + historyPhone;
            }
          } else {
            historyPhone = phone;
          }
          historyPhone = historyPhone.split(',').splice(0, 5).join(',');
          localStorage.setItem(AppLocalKey.historyPhone, historyPhone);
          let res = await apiGetEmCount();
          let data = res.data;
          if (data.data <= 0) {
            naviate('/em-list', { state: { backToOut: true } });
          } else {
            naviate('/home', { replace: true });
          }
        } else {
          showToast(userInfoData.msg ?? '登录失败');
        }
      } else {
        showToast(data.msg ?? '登录失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '登录失败');
    } finally {
      LoadingMask.hide();
    }
  }
  return (
    <Page className="d-flex-c login-page" contentClassName="flex-1 d-flex-c h-1 pos-r">
      <img className="bw-100 pos-a" src="/pic/pic_login_bg.png" alt="" />
      <div className="pos-a l-0 r-0 t-0 b-0 pl-30 pr-30 pt-30 d-flex-c overflow-y">
        <img className="icon-40 border-radius-8" src="/pic/logo.png" alt="" />
        <div className="font-size-30 mt-5">你好</div>
        <div className="font-size-20 mt-5">欢迎使用「网司令」</div>
        {loginType === 'emNumber' && (
          <>
            <div className="mt-40">设备号</div>
            <div className=" d-flex-r h-36 mt-10 bg-gray border-radius-60 ai-center">
              <input
                className="flex-1 ml-10 mr-10 h-36"
                placeholder="请输入设备号"
                value={emNumber}
                onChange={(e) => setemNumber(e.target.value)}
                onBlur={(e) => getCheckEmNumLogin(e.target.value)}
              />
              <img className="icon-20 mr-10" src="/pic/icon_scan_p.png" alt="" onClick={scanCode} />
            </div>
          </>
        )}
        <div className="mt-40">手机号</div>
        <div className="border h-36 mt-10 bg-gray d-flex-r border-radius-60 ai-center pos-r">
          <input
            className="flex-1 ml-10 mr-10 h-36"
            placeholder="请输入手机号"
            value={phone}
            disabled={!isBindEmNumber && loginType === 'emNumber'}
            inputMode="numeric"
            maxLength={11}
            onFocus={() => setShowHistoryPhone(true)}
            onBlur={() => {
              delay(50).then(() => setShowHistoryPhone(false));
            }}
            onChange={(e) => setPhone(e.target.value)}
          />
          {!!phone && (
            <img className="icon-14 mr-10" src="/pic/icon_close_black.png" alt="" onClick={() => setPhone('')} />
          )}
          {!!showHistoryPhone && !!historyPhone.length && (
            <div className="z-10 pos-a t-40 bg-white d-shadow l-0 r-0 border-radius-8">
              {historyPhone.map((i, idx) => (
                <div
                  key={`${i}${idx}`}
                  className={`p-10 border-bottom ${i.toString() === phone ? 'bg-gray' : ''}`}
                  onClick={() => {
                    setPhone(i.toString());
                  }}
                >
                  {i}
                </div>
              ))}
            </div>
          )}
        </div>
        {loginType === 'smsCode' && (
          <>
            <div className="mt-30">验证码</div>
            <div className=" d-flex-r h-36 mt-10 bg-gray border-radius-60 ai-center">
              <input
                className="flex-1 ml-10 mr-10 h-36"
                placeholder="请输入验证码"
                value={captcha}
                inputMode="numeric"
                maxLength={6}
                onChange={(e) => setCaptcha(e.target.value)}
              />
              <div
                className={`font-size-12 mr-10 ${timing ? 'text-color-p-t' : 'text-color-p'}`}
                onClick={timing ? undefined : handleGetCaptcha}
              >
                {timing ? `${captchaTime}s` : '获取验证码'}
              </div>
            </div>
          </>
        )}
        <div className="flex-1 mt-40"></div>
        <div className="bw-100">
          <Button long type="primary" size="lg" shape="circle" onClick={handleLogin}>
            登录/注册
          </Button>
        </div>
        <div className="d-flex-r ai-center jc-center bw-100 mt-20">
          <RadioBox className="mr-10" value={checkProtocol} onChange={() => setCheckProtocol(!checkProtocol)} />
          <div className="font-size-12">
            <span onClick={() => setCheckProtocol(!checkProtocol)}>已阅读并同意</span>
            <span className="text-color-p" onClick={() => navigate('/protocol', { state: ProtocolType.userAgreement })}>
              《用户协议》
            </span>
            和
            <span
              className="text-color-p"
              onClick={() => navigate('/protocol', { state: ProtocolType.privacyAgreement })}
            >
              《隐私政策》
            </span>
          </div>
        </div>
        <div className="flex-1 mt-40 d-flex-r jc-center">
          <span className="text-color-p" onClick={() => setLoginType(loginType === 'smsCode' ? 'emNumber' : 'smsCode')}>
            {loginType === 'smsCode' ? '收不到验证码？点击这里' : '验证码登录'}
          </span>
        </div>
        {/* <div className="mb-20 bw-100 text-center text-color-9">
          <span onClick={() => naviate('/customer', { state: { emNumber: main.nextBindEm } })}>联系客服</span>
          <span className="ml-10 mr-10">|</span>
          <span
            onClick={() => {
              // 取值优先级：
              // 0. 卡库
              // 1. 系统参数配置的电话
              // 2. config.js配置的电话

              let tel400 = serverPhone;
              if (!tel400 && main.configList) {
                let config = main.configList.find((i) => i.configKey === main.tel400Key);
                if (config) {
                  tel400 = config.configValue!;
                }
              }
              if (!tel400) {
                tel400 = main.tel400;
              }
              window.open(`tel:${tel400}`);
            }}
          >
            服务热线
          </span>
        </div> */}
      </div>
    </Page>
  );
}
